import "slick-carousel"

export default {
	init() {

		const $slider = $('.slider-restaurant-head')

		$slider.slick({
			slidesToShow: 1,
			nextArrow: '<div class="slider-next"></div>',
			prevArrow: '<div class="slider-prev"></div>',
			dots: false,
			variableWidth: true,
			infinite: true
		})
		

	}
}
